import React from 'react';
import { Link } from 'react-router-dom';

import Grade from '../../../types/Grade';
import StudentResults from '../../../types/StudentResults';
import Student from '../../../types/Student';

import handleApiErrors from '../../../lib/apiClient/handleErrors';
import deleteStudent from '../../../lib/apiClient/students/delete';

import Row from '../../common/ui/Table/Row';
import TableCell from '../../common/ui/Table/Cell';
import { calculateStudentNorms } from '../../../lib/studentResultsCalculator';

interface Props {
  student: Student;
  studentResults: StudentResults;
  grades: Record<number, Grade>;
  unauthorizedCallback: () => void;
  showError: (text: string) => void;
}

type Variant = 'common' | 'warning' | 'danger';

const StudentsTableRow = ({
  student: {
    id,
    username,
    sex,
    age,
    schoolId,
    grade: studentGrade,
    orphan,
    visionImpairment,
    hearingImpairment,
    musculoskeletalImpairment,
    doneTesting,
  },
  studentResults,
  grades,
  unauthorizedCallback,
  showError,
}: Props) => {
  const gradeId = studentGrade?.id;
  if (schoolId === undefined || gradeId === undefined) return <></>;

  const destroy = () =>
    handleApiErrors(deleteStudent(id), unauthorizedCallback, showError);

  const norms = calculateStudentNorms(studentResults?.testingTypeId, sex);

  return (
    <Row destroy={destroy}>
      <TableCell>{username ?? ''}</TableCell>

      <TableCell>{sex ?? ''}</TableCell>

      <TableCell>{age?.toString(10) ?? ''}</TableCell>

      <TableCell>
        {Object.values(grades).find((g) => g.id === studentGrade?.id)?.name ??
          ''}
      </TableCell>

      <TableCell>
        {Object.values(grades).find((g) => g.id === studentGrade?.id)?.letter ??
          ''}
      </TableCell>

      <TableCell>{orphan ? 'Да' : 'Нет'}</TableCell>

      <TableCell>{visionImpairment ? 'Да' : 'Нет'}</TableCell>

      <TableCell>{hearingImpairment ? 'Да' : 'Нет'}</TableCell>

      <TableCell>{musculoskeletalImpairment ? 'Да' : 'Нет'}</TableCell>

      <TableCell variant="common">{doneTesting ? 'Да' : 'Нет'}</TableCell>

      <TableCell
        variant={studentResults?.KVERIPO > norms.KVERIPO ? 'danger' : 'common'}
      >
        <Link to={`/teacher/students/${id}`}>
          {studentResults?.KVERIPO ?? 0}
        </Link>
      </TableCell>

      <TableCell
        variant={(() => {
          if (studentResults?.IRP >= norms.IRP[1]) return 'extreme';
          if (studentResults?.IRP > norms.IRP[0]) return 'danger';
          return 'common';
        })()}
      >
        <Link to={`/teacher/students/${id}`}>{studentResults?.IRP ?? 0}%</Link>
      </TableCell>

      <TableCell
        variant={
          ['common', 'danger', 'extreme'][
            studentResults?.result ?? 0
          ] as Variant
        }
      >
        <Link to={`/teacher/students/${id}`}>
          {
            ['Низкая', 'Высокая', 'Высочайшая'][
              studentResults?.result ?? 0
            ]
          }
        </Link>
      </TableCell>
    </Row>
  );
};

export default StudentsTableRow;
